import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface IDefinitionListProps {
  flag?: 'def-lst' | 'def-lst2'
  hasPadding?: boolean
  isFlex?: boolean
  className?: string
  children: ReactNode
}

export const Wrapper = (props: IDefinitionListProps) => {
  const { flag = 'def-lst' } = props
  const className = classnames(
    flag,
    {
      'def-lst--pb': props.hasPadding,
      'flex-box flex-box--pb0': props.isFlex,
    },
    props.className,
  )

  return <dl className={className}>{props.children}</dl>
}
